
































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { DataTableAction, DetailsField, Filter } from '@/utils/types'
import UserCrud from '../components/UserCrud.vue'
import FullscreenDetails from '../components/FullscreenDetails.vue'
import { Prop } from 'vue-property-decorator'
import { DataTableHeader } from 'vuetify'
import _ from 'lodash'
import Filters from './Filters.vue'
import { debounce } from '@/utils/helpers'

@Component({
  components: { UserCrud, FullscreenDetails, Filters }
})
export default class DataTable extends Vue {
  @Prop(Array) readonly actions!: DataTableAction[]
  @Prop(Array) readonly filters!: Filter<string | number>[]
  @Prop(Array) readonly detailsDialogFields?: DetailsField[]
  @Prop(Array) readonly headers!: DataTableHeader[]
  @Prop(Boolean) readonly loading!: boolean
  @Prop(Array) readonly items!: []
  @Prop(String) readonly searchLabel?: string
  @Prop(Number) readonly totalItems!: number
  @Prop(String) readonly collectionName!: string
  @Prop({ default: 3 }) readonly detailsDialogNumColumns!: number
  @Prop({ default: false }) readonly enableSort!: boolean
  @Prop({ default: 100 }) readonly itemsPerPage!: number

  detailsDialog = false
  detailsDialogModel: unknown = null
  page = 1
  search = ''
  searchTimeout = 0

  async debounceSearch() {
    this.searchTimeout = debounce(async () => {
      this.$emit('search', this.search)
    }, this.searchTimeout)
  }

  handleCreateItemClicked() {
    this.$emit('createItem')
  }

  handleClearAllFilters() {
    this.$emit('clearAllFilters')
  }

  handleExportDataClicked() {
    this.$emit('exportData')
  }

  paginateTo(page: number) {
    this.$emit('paginate', page)
  }

  handleTableRowClicked(item: unknown) {
    if (this.$listeners.rowClick) {
      this.$emit('rowClick', item)
    } else if (this.detailsDialogFields?.length) {
      this.detailsDialogModel = item
      this.detailsDialog = true
    }
  }

  get computedHeaders(): DataTableHeader[] {
    if (this.actions) {
      return [
        ...this.headers,
        { text: 'פעולות', value: 'actions', sortable: false }
      ]
    }
    return this.headers
  }

  get isRowReactive(): boolean {
    return !!(this.$listeners.rowClick || this.detailsDialogFields?.length)
  }

  get detailsDialogTitle(): string {
    return `${this.headers[0]?.text}: ${_.get(
      this.detailsDialogModel,
      this.headers[0]?.value,
      ''
    )}`
  }

  get detailsDialogMDColumns(): number {
    switch (this.detailsDialogNumColumns) {
      case 1:
        return 12
      case 2:
        return 6
      case 3:
        return 4
      case 4:
        return 3
      default:
        return 3
    }
  }
}
